import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

interface IProps {
  prodUrl: (value: string) => string;
}

const MobilePillowsSection = ({ prodUrl }: IProps): ReactElement => {
  const { t: tMobile } = useTranslation('', {
    keyPrefix: '$pages.$home.$mobileHomePage.$pillowsSection',
  });

  return (
    <section className="mobile-pillows">
      <div className="title-wrap">
        <h2>{tMobile('pillowTitle')}</h2>
        <h3 className="subtitle">{tMobile('pillowSubTitle')}</h3>
      </div>
      <Link href={prodUrl('renaissancePillow')} className="img-frame right">
        <picture>
          <source srcSet="/images/misc/fill.gif" media="(min-width: 769px)" />
          <img
            src="/statics/img/mobile/pillow.webp"
            alt={tMobile('pillowImageAlt')}
            width={667}
            height={360}
            loading="eager"
            decoding="async"
            fetchPriority="low"
          />
        </picture>
      </Link>
      <h3 className="subtitle frame">
        {tMobile('morePillows')}
        <div className="connectors" />
      </h3>
      <div className="product-grid">
        <Link href={prodUrl('featherDownPillow')} aria-label="Product Eco Pillow">
          <img
            src="/statics/img/mobile/feather-down-pillow.webp"
            alt={tMobile('featherDownPillowImageAlt')}
            width={368}
            height={199}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <h3 className="subtitle">{tMobile('featherDownPillow')}</h3>
        </Link>
        <Link href={prodUrl('fibrePillow')} aria-label="Product Down Pillow">
          <img
            src="/statics/img/mobile/synthetic-pillow.webp"
            alt={tMobile('fibrePillowImageAlt')}
            width={368}
            height={199}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <h3 className="subtitle">{tMobile('fibrePillow')}</h3>
        </Link>
      </div>
    </section>
  );
};

export default MobilePillowsSection;
